export default [
  {
    id: 1,
    zhiwei: '血透医生',
    xueli: '北京 · 经验不限 · 本科',
    miaoshu: [
      '1、在公司总经理领导下，在临床支持中心负责人指导下开展临床培训指导工作。',
      '2、制定工作计划，组织实施，经常督促检查，按期总结汇报。',
      '3、协助透析中心医务人员，进行透析医疗工作，完成医疗任务。',
      '4、定期到透析中心查房，共同研究解决重危疑难病例诊断治疗上的问题。',
      '5、负责组织透析医疗人员学习、运用国内外透析先进经验指导临床实践，提高医疗质量，及时总结经验。',
      '6、监督透析中心，认真贯彻执行各项规章制度和技术操作规程。',
      '7、遵照中心规章制度及时解决科内发生的各种问题，必要时应上报中心领导。',
      '8、协助销售做好售前售后临床支持工作。',
      '9、指导本部门工组人员的培训工作。',
      '10、担任一定范围的临床教学，指导新入职人员工作。',
      '11、依据公司发展随时调整工作内容。',
    ],
    zege: [
      '1、已取得医师资格证书；',
      '2、有血透经验或肾内科工作经验者优先考虑；',
      '3、愿意从事血透工作。',
    ],
  },
  {
    id: 2,
    zhiwei: '透析室护士',
    xueli: '北京 · 经验不限 · 不限学历',
    miaoshu: [
      '1、参与所在透析室患者的日常透析治疗；',
      '2、协助进行患者教育干预；',
      '3、对透析室患者病情观察及并发症处理；',
      '4、对透析室患者病历档案记录等日常工作。',
    ],
    zege: [
      '1、护理专业中专及以上学历，必须持有护士从业资格证；',
      '2、有1年以上其它科室护理工作经验，有血液透析工作经验者优先考虑；',
      '3、掌握护理基础理论及有关的医学知识和本病区常见疾病诊治护理原则；',
      '4、责任心强，对工作充满热情，耐心，较强的组织协调能力。',
    ],
  },
  {
    id: 3,
    zhiwei: 'python开发工程师',
    xueli: '北京 · 经验不限 · 专科',
    miaoshu: [
      '1.参与产品或相关功能的讨论和开发，编写相应的需求、设计文档等。',
      '2.独立进行数据处理系统功能的开发、调试及问题诊断工作。',
      '3.根据系统的运行情况，进行系统或功能的改进和优化。',
      '4.开发维护Linux服务器云端图像处理软件并负责图形算法的实现。',
    ],
    zege: [
      '1.具备通信、电子工程、自动化、计算机及其相关专业，专科及以上学历。',
      '2.具备2年以上Python开发经验及以上图像处理开发经验，具有深度学习图像处理相关经验者优先。',
      '3.有较好数学基础及算法基础，能够使用RPCA算法仿真。',
      '4.精通基于linux软件开发，熟悉常用数据结构、多线程等。',
      '5.了解socket及常用通信协议如tcp',
      '6.熟悉主流数据库、并对数据库优化有一定的经验。',
      '7.有图形图象处理的开发经验者优先，如图像分割、目标检测、特征提取、图像配准等。',
      '8.有除Python外，要求会任一主流语言开发经验(Java、PHP、javascript等)。',
    ],
  },
  {
    id: 4,
    zhiwei: '产品经理',
    xueli: '北京 · 2年以上 · 本科',
    miaoshu: [
      '1.负责公司医疗服务产品、健康产品的设计。',
      '2.负责公司数字化、信息化产品的需求调研。',
      '3.熟悉互联网产品设计理念及方法，对用户体验有独到认识。',
      '4.负责对接医院、运营等部门，收集需求制定产品计划并设计原型图。',
      '5.负责推动各项业务发展，提升营运效益，确保运营目标的实现。',
      '6.有微信公众号，小程序，移到端产品生态搭建经验优先。',
      '7.较强的跨部门组织、沟通和协调资源并能承受较大的工作压力。',
    ],
    zege: [
      '1.本科以上学历，至少2年以上互联网产品工作经验。',
      '2.有独立负责过一个项目的经验，有医疗行业软件产品(医疗HIS、LIS、SaaS、在线医疗系统产品)）经验。',
      '3.熟练使用XMind、MindMaster、墨刀、Axure、Visio、Microsoft Project等产品经理相关工具并设计原型图。',
      '4.熟悉互联网产品设计理念及方法，对用户体验有独到认识。',
      '5.具备较强的逻辑思维能力、学习创新能力、数据分析能力和语言表达能力。',
      '6.具有医学护理相关专业、医护工作经验优先。',
      '7.具有互联网B端C端相关工作经验优先。',
    ],
  },
  {
    id: 5,
    zhiwei: '售前工程师',
    xueli: '北京 · 经验不限 · 专科',
    miaoshu: [
      '1.负责与客户进行长期有效沟通，充分理解客户需求并完成跟进和梳理，向技术、产品、运营等团队有效传达客户的需求。',
      '2.全面了解公司已有的产品线及后续的规划方向，完成解决方案编制、产品宣传资料撰写、宣讲PPT制作l以及演示宣讲工作。',
      '3.负责主导具体项目技术方案的用户引导及确定，完成招投标方案的编制工作，参加招投标会议并进行技术讲解和答疑。',
      '4.跟踪和分析部门的需求变化、行业市场动态变化，配合公司制定后续的产品研发及市场开拓计划。',
    ],
    zege: [
      '1.专科及以上学历，专业不限。',
      '2.3年以上IT行业从业经验，2年以上医疗行业运作、策划推广或规划设计经验，有亲和力，具备较强的客户引导能。',
      '3.具备较强的规划能力、文字功底和语言表达能力，具备专业的方案演讲和产品介绍能力。 ',
      '4.有强烈的事业心和团队协作精神，有积极乐观的心态，善于与其他人打交道。',
    ],
  },
]
